import React from "react";
import { isNil } from "lodash";
import {
  IssueCustomAttributeDefinition,
  IssueCustomAttributeType,
} from "@adsk/acc-issues-types";
import { AtomicTextField } from "@adsk/acc-issues-common/components/primitive/AtomicTextField";
import { useGetSingleCustomFieldSchema } from "../../utils/validation/entitySchemas";

export const AtomicCustomField = ({
  testId,
  attribute,
  value,
  containerRef,
  handleCustomAttributeChange,
  isRequired,
  disabled,
  placeholder,
  viewOnly = false,
}: {
  testId?: string;
  attribute: IssueCustomAttributeDefinition;
  value: string | number | boolean | undefined;
  containerRef?: React.MutableRefObject<null>;
  handleCustomAttributeChange: (value: any) => void;
  isRequired: boolean;
  disabled: boolean;
  placeholder: string;
  viewOnly?: boolean;
}) => {
  const getSingleCustomFieldSchema = useGetSingleCustomFieldSchema();

  return (
    <AtomicTextField
      testId={testId}
      fieldKey={`${attribute.dataType}-${attribute.id}`}
      disabled={disabled}
      showDisabledReason={!viewOnly}
      isMultiLine={attribute.dataType === IssueCustomAttributeType.Paragraph}
      label={attribute.title}
      infoTooltipContent={attribute.description}
      value={(isNil(value) ? "" : value).toString()}
      containerRef={containerRef}
      validator={text => {
        const fieldSchema = getSingleCustomFieldSchema({
          attribute,
          isRequired: isRequired,
        });
        try {
          fieldSchema.validateSync(text);
        } catch (error: any) {
          return error.message;
        }
      }}
      onChange={handleCustomAttributeChange}
      placeholder={placeholder}
      required={isRequired}
    />
  );
};
